import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function Login() {
  const { isAuthenticated, login, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  const handleLogin = () => {
    login();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#282828] via-[#4c1d95] to-[#282828]">
      <div className="max-w-md w-full space-y-8 p-10 bg-[#282828]/80 backdrop-blur-sm rounded-2xl border border-[#1283EB]/30 shadow-2xl">
        {/* Logo/Header */}
        <div className="text-center">
          <img
            src="/aiia-logo-white.svg"
            alt="aiia"
            className="h-16 mx-auto mb-4"
          />
          <h2 className="text-xl text-[#F8F3EC]">
            Partner Portal
          </h2>
          <p className="mt-3 text-sm text-white/60">
            Manage your clients and grow your business
          </p>
        </div>

        {/* Login Button */}
        <div className="mt-8">
          <a
            href="/auth/partner/login"
            onClick={(e) => {
              e.preventDefault();
              handleLogin();
            }}
            role="button"
            className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-[#1283EB] hover:bg-[#1283EB]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1283EB] transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <span>Loading...</span>
            ) : (
              <span>Sign in with aiia</span>
            )}
          </a>
        </div>

        {/* Footer */}
        <div className="text-center space-y-3">
          <p className="text-sm text-white/50">Secure OAuth authentication</p>

          {/* Registration Link */}
          <div className="pt-4 border-t border-white/10">
            <p className="text-sm text-white/60">
              New to aiia?{' '}
              <a
                href="/register"
                className="text-[#1283EB] hover:text-[#1283EB]/80 font-medium transition-colors"
              >
                Join the team →
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
